import {
  refreshApiCookie,
  refreshPortalCookie,
  urlFormat,
  getHeaders,
  getJsonOrDefault,
} from "./functions";

/**
 * Refreshes the apitoken and portal cookie(lp2004b)
 */
export const refreshToken = () => {
  refreshApiCookie();
  refreshPortalCookie();
};

/**
 *
 * @param {string} url - endpoint url to query against
 * @param {object} parameters - object mapping of url parameters to values, e.g. api/:id gets value from object.id
 * @returns the response body as json if possible, otherwise plaintext.
 */
export const GET = async (url, parameters = {}) => {
  const headers = getHeaders(false);

  return fetch(urlFormat(url, parameters), { method: "GET", headers })
    .then((response) => response.text())
    .then((data) => getJsonOrDefault(data));
};

/**
 *
 * @param {string}  url - endpoint url
 * @param {object}  parameters - object mapping of url parameters to values, e.g. api/:id gets value from object.id
 * @param {object}  body - body to send
 * @param {boolean} bodyAsJson - flag which states if the body is JSON or not.
 * @returns the response object
 */
export const RAW_POST = (url, parameters = {}, body, bodyAsJson = true) => {
  const headers = getHeaders(bodyAsJson);

  return fetch(urlFormat(url, parameters), {
    method: "POST",
    headers,
    body: bodyAsJson ? JSON.stringify(body) : body,
  });
};

/**
 *
 * @param {string}  url - endpoint url
 * @param {object}  parameters - object mapping of url parameters to values, e.g. api/:id gets value from object.id
 * @param {object}  body - body to send
 * @param {boolean} bodyAsJson - flag which states if the body is JSON or not.
 * @returns  the response body in json if possible, otherwise text.
 */
export const POST = async (url, parameters = {}, body, bodyAsJson = true) => {
  return RAW_POST(url, parameters, body, bodyAsJson)
    .then((response) => response.text())
    .then((data) => getJsonOrDefault(data));
};

/**
 *
 * @param {string}  url - endpoint url
 * @param {object}  parameters - object mapping of url parameters to values, e.g. api/:id gets value from object.id
 * @param {object}  body - body to send
 * @param {boolean} bodyAsJson - flag which states if the body is JSON or not.
 * @returns the response body in json if possible, otherwise text.
 */
export const DELETE = async (url, parameters = {}, body, bodyAsJson = true) => {
  return RAW_DELETE(url, parameters, body, bodyAsJson)
    .then((response) => response.text())
    .then((data) => getJsonOrDefault(data));
};

/**
 *
 * @param {string}  url - endpoint url
 * @param {object}  parameters - object mapping of url parameters to values, e.g. api/:id gets value from object.id
 * @param {object}  body - body to send
 * @param {boolean} bodyAsJson - flag which states if the body is JSON or not.
 * @returns the response object.
 */
export const RAW_DELETE = (url, parameters = {}, body, bodyAsJson = true) => {
  const headers = getHeaders(bodyAsJson);

  return fetch(urlFormat(url, parameters), {
    method: "DELETE",
    headers,
    body: bodyAsJson ? JSON.stringify(body) : body,
  });
};

/**
 *
 * @param {string}  url - endpoint url
 * @param {object}  parameters - object mapping of url parameters to values, e.g. api/:id gets value from object.id
 * @param {object}  body - body to send
 * @param {boolean} bodyAsJson - flag which states if the body is JSON or not.
 * @returns the response body in json if possible, otherwise text.
 */
export const PATCH = async (url, parameters = {}, body, bodyAsJson = true) => {
  const headers = getHeaders(bodyAsJson);

  return fetch(urlFormat(url, parameters), {
    method: "PATCH",
    headers,
    body: bodyAsJson ? JSON.stringify(body) : body,
  })
    .then((response) => response.text())
    .then((data) => getJsonOrDefault(data));
};

/**
 *
 * @param {string} url - endpoint url
 * @param {object} parameters - object mapping of url parameters to values, e.g. api/:id gets value from object.id
 * @param {object} body - body to send
 * @param {boolean} bodyAsJson - flag which states if the body is JSON or not.
 * @returns the response body in json if possible, otherwise text.
 */
export const PUT = async (url, parameters = {}, body, bodyAsJson = true) => {
  return RAW_PUT(url, parameters, body, bodyAsJson)
    .then((response) => response.text())
    .then((data) => getJsonOrDefault(data));
};

/**
 *
 * @param {string} url - endpoint url
 * @param {object} parameters - object mapping of url parameters to values, e.g. api/:id gets value from object.id
 * @param {object} body - body to send
 * @param {boolean} bodyAsJson - flag which states if the body is JSON or not.
 * @returns the response object
 */
export const RAW_PUT = async (
  url,
  parameters = {},
  body,
  bodyAsJson = true,
) => {
  const headers = getHeaders(bodyAsJson);

  return fetch(urlFormat(url, parameters), {
    method: "PUT",
    headers,
    body: bodyAsJson ? JSON.stringify(body) : body,
  });
};
